import { locale } from "primereact/api";
import { useUserState } from "store/user-store";

const usePrimeLocale = () => {
  const language = useUserState(state => state.getLanguage());
  locale(language);
};

export default usePrimeLocale;
